import { c as _c } from "react/compiler-runtime";
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { H4 } from '@algoacademy/design-system/web/marketing/typography/Heading/H4';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph/P2';
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
type GoalPath = {
  title: string;
  leadsTo: string;
};
const GOAL_PATHS: GoalPath[] = [{
  title: 'Podstawy programowania',
  leadsTo: 'Ścieżka dla ambitnych uczniów, którzy jeszcze nie zaczęli przygody z programowaniem - od pierwszych linii kodu po solidne fundamenty pod dalszy rozwój'
}, {
  title: 'Olimpiada Informatyczna Juniorów',
  leadsTo: 'Trening pod OIJ dla uczniów szkół podstawowych - od podstaw algorytmiki po zadania w stylu olimpijskim i systematyczne przygotowanie do kolejnych etapów'
}, {
  title: 'Olimpiada Informatyczna',
  leadsTo: 'Trening pod ogólnopolskie zawody dla licealistów. Zadania w stylu olimpijskim, podejście do kolejnych etapów i umiejętności, które odróżniają finalistów'
}, {
  title: 'Rozmowy rekrutacyjne w IT',
  leadsTo: 'Przygotowanie do rozmów o pracę w firmach technologicznych - zadania algorytmiczne, wiedza techniczna i umiejętności miękkie, które wyróżnią Cię podczas rozmowy z rekruterem'
}, {
  title: 'Praktyczne AI',
  leadsTo: 'Wprowadzenie do sztucznej inteligencji w nauce i pracy - dobór właściwych narzędzi, skuteczna praca z nimi i granice, o których warto wiedzieć'
}, {
  title: 'Rekrutacja na studia',
  leadsTo: 'Przygotowanie do rekrutacji na informatykę i kierunki ścisłe - matura z matematyki lub informatyki, egzaminy wstępne i budowanie mocnego profilu kandydata'
}];
export function GroupMentoringGoalPaths() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VerticalSpacer size="content" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="space-y-1"><H4 id="goal-paths-heading" className="text-contentPrimary">Do czego Cię przygotowujemy</H4><P2 className="text-contentSecondary">Na początku ustalamy razem, do czego zmierzasz - olimpiada, studia, praca, wykorzystanie AI - i dobieramy materiał pod ten cel. Aktualnie w ramach mentoringu podstawowego wspieramy następujące ścieżki:</P2></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section aria-labelledby="goal-paths-heading" className="space-y-4">{t0}{t1}<ul className="space-y-4">{GOAL_PATHS.map(_temp)}</ul></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(path) {
  return <li key={path.title}><IconOnTheLeftWithContentLayout mainContent={<P2 className="text-contentSecondary"><strong className="block font-semibold text-contentPrimary">{path.title}</strong>{path.leadsTo}</P2>} /></li>;
}